import React, { useState, useEffect } from 'react';

const links = [
  { id: 'about', label: 'About' },
  { id: 'experience', label: 'Experience' },
  { id: 'skills', label: 'Skills' },
  { id: 'projects', label: 'Projects' },
  { id: 'contact', label: 'Contact' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setOpen(false);
  };

  return (
    <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner">
        <a href="#" className="nav__logo" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          AK
        </a>
        <button
          type="button"
          className="nav__toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
        >
          <span className={open ? 'nav__toggle-bar nav__toggle-bar--open' : 'nav__toggle-bar'} />
          <span className={open ? 'nav__toggle-bar nav__toggle-bar--open' : 'nav__toggle-bar'} />
          <span className={open ? 'nav__toggle-bar nav__toggle-bar--open' : 'nav__toggle-bar'} />
        </button>
        <ul className={`nav__links ${open ? 'nav__links--open' : ''}`}>
          {links.map(({ id, label }) => (
            <li key={id}>
              <button type="button" className="nav__link" onClick={() => handleClick(id)}>
                {label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
